<template>
  <nuxt />
</template>
<script>
export default {
  head() {
    return {
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=Edge,chrome=1' },
        { name: 'viewport', content: 'width=1440' }
      ],
      link: [
        { rel: 'icon', type: 'image/x-icon', href: 'https://mapapi.qq.com/web/lbs/logo/favicon.ico' },
      ],
    };
  },
};
</script>
<style lang="less">
@import 'highlight.js/styles/atom-one-light.css';
@import '@/static/css/common.css';
@import '@/static/css/article.less';
</style>
